// extracted by mini-css-extract-plugin
export default {"container":"Table_container__YmQNy","actions":"Table_actions__zexxr"};